import React, { useState, useEffect } from "react"
import './index.css';
import { Table, Dropdown, Spinner } from "react-bootstrap";
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import { getBetIds, getLoginToken, ORDERSTTAUS_API, MARKET_FETCH_URL, getNewBetIds } from './constants/utils'
const BfResult = (props) => {
  const [betDetails, setBetDetails] = useState([]);
  const [marketDetails, setMarketDetails] = useState([]);
  const [filterDate, setFilterDate] = useState('Just For Today');
  const [loading, setLoading] = useState(true);
  const fetchedMarketIds = React.useRef(new Set());

  function updateMarketData(marketData) {
    //check if marketDetails contains marketData if not then update it
    //console.log("vivek is great.." + JSON.stringify(marketDetails.length));
    var alreadyFetched = marketDetails.map(x => x.bfPlaceMarketId).includes(marketData.bfPlaceMarketId)
    || marketDetails.map(x => x.bfMarketId).includes(marketData.bfMarketId);
    if (!alreadyFetched) {
      //dont need runner metadata delete it.
      marketData.runners.forEach(x => delete x['metadata'])
      marketDetails.push(marketData)
      //console.log("size of market is:" + marketDetails.length)
    }
  }

  useEffect(() => {
    function updateStatus() {
      var allBetIds = getBetIds();
      var newBetId = getNewBetIds();//current placed bet from browser
      //var savedClearedBets = getClearedBets().map(x => x.betId);
      //Always update status of new betI ids we dont know when it will move to
      //cleared bet. Dont call for already saved cleared bet.
      //let difference = allBetIds.filter(x => !savedClearedBets.includes(x)).concat(newBetId);

      var betIdsToCall = props.type === 'current' ? newBetId : allBetIds;
      if (betIdsToCall && betIdsToCall.length > 0) {
        const postRequestPara = {
          "ssoid": getLoginToken(),
          "orderIds": betIdsToCall,
        }
        axios.post(ORDERSTTAUS_API + props.type, postRequestPara)
          .then((res) => {
            //console.log("Result of LOGIN API ::" + res.data)
            var betDetails = res.data
            if (betDetails) {
              betDetails.forEach(element => {
                if (!fetchedMarketIds.current.has(element.marketId)) {
                  fetchedMarketIds.current.add(element.marketId);
                  getMarketDetails(element.marketId)
                    .then(result => {
                      updateMarketData(result.data)
                    })
                }
              })
              setBetDetails(betDetails)
            }
            setLoading(false);
          },
            (error) => {
              setLoading(false);
              //console.log("Result of API 3 returns Error!!!" + error)
              //NotificationManager.error('Error in Login', '', 5000, () => {
              //console.log('Error message notification clicked');
            });
      } else {
        setLoading(false);
      }
    }
    updateStatus();
    const intervalId = setInterval(updateStatus, props.refreshTime);
    window.addEventListener('betCancelled', updateStatus);
    return () => {
      clearInterval(intervalId);
      window.removeEventListener('betCancelled', updateStatus);
    };
  }, []);



  function getMarketDetails(marketId) {
    return axios.get(MARKET_FETCH_URL + marketId);
  }

  function getMarketName(marketId) {
    let x = marketDetails
      .filter(marketData => marketData.bfMarketId === marketId || Object.values(marketData.marketInfoMarketId).includes(marketId))
      .map(element => element.bfMarketName + ' ' + element.bfTime);
    return x.length > 0 ? x[0] : marketId;
  }



  function getSelectionName(marketId, selectionId) {
    let x = marketDetails.filter(marketData => marketData.bfMarketId === marketId || Object.values(marketData.marketInfoMarketId).includes(marketId))
      .flatMap(element => element.runners)
      .filter(element => element.selectionId === Number(selectionId))
      .map(element => element.runnerName)

    return x.length > 0 ? x[0] : selectionId
  }


  function renderBet(bet, index) {
    //console.log("Market Details" + JSON.stringify(marketDetails))
    return (
      <tr key={index}>
        <td>{index}</td>
        <td>{bet.placedDate ? bet.placedDate.substring(0, 10) : bet.matchedDate ? bet.matchedDate.substring(0, 10) : new Date().toString()}</td>
        <td>{getMarketName(bet.marketId)}</td>
        <td>{getSelectionName(bet.marketId, bet.selectionId)}</td>
        <td>{bet.betId}</td>
        <td>{bet.side}</td>
        <td>{bet.profit}</td>
        <td>{bet.priceMatched ? bet.priceMatched : bet.averagePriceMatched ? bet.averagePriceMatched : bet.priceSize ? bet.priceSize.price : ''}</td>
        <td>{bet.sizeSettled ? bet.sizeSettled : bet.sizeMatched ? bet.sizeMatched : bet.priceSize ? bet.priceSize.size : ''}</td>
        <td>{bet.betStatus ? bet.betStatus : bet.status}</td>
      </tr>
    )
  }
  function filterByStaus(bet) {
    if (!props.filterStatus) {
      return true;
    }
    return props.filterStatus ? bet.status === props.filterStatus : true;
  }

  function filterByBetStaus(bet) {
    if (!props.filterBetStatus) {
      return true
    }
    return props.filterBetStatus && bet.betStatus ? props.filterBetStatus.includes(bet.betStatus) : true;
  }

  function isTodayDate(todayDate, otherDate) {
    if (
      otherDate.getDate() === todayDate.getDate() &&
      otherDate.getMonth() === todayDate.getMonth() &&
      otherDate.getYear() === todayDate.getYear()
    ) {
      return true;
    } else {
      return false;
    }
  }

  function filterByDate(bet) {
    try {
      if (props.showDateDropDown === 'false') {
        return true;
      }
      const filterCriteria = filterDate;
      const placedDate = new Date(bet.placedDate ? bet.placedDate : bet.matchedDate);
      const toDate = new Date();
      if (filterCriteria === 'Just For Today') {
        return isTodayDate(placedDate, toDate)
      } else {
        var fromDate = new Date();
        fromDate.setHours(0);
        fromDate.setMinutes(0);
        fromDate.setSeconds(0);
        if (filterCriteria === 'From Yesterday') {
          fromDate.setDate(fromDate.getDate() - 1);

        } else if (filterCriteria === 'Last 7 Days') {
          fromDate.setDate(fromDate.getDate() - 7);
        } else if (filterCriteria === 'Last 30 Days') {
          fromDate.setDate(fromDate.getDate() - 30);
        } else if (filterCriteria === 'Last 3 Months') {
          fromDate.setDate(fromDate.getDate() - 90);
        }
        if (placedDate.getTime() <= toDate.getTime() &&
          placedDate.getTime() >= fromDate.getTime()) {
          return true;
        } else {
          return false;
        }
      }
    } catch (error) {
      console.log("error filtering by date", error)
    }
    return true;
  }

  function handleSelect(event) {
    setFilterDate(event)
  }
  //console.log("showDateDropDown" + props.showDateDropDown);
  return (
    <>
      {props.showDateDropDown === 'true' ? (
        <div style={{ display: "flex" }}>
          <label style={{ margin: "5px", fontSize: "14px", padding: "5px", marginBottom: "15px", fontWeight: "700" }}>Period</label>
          <Dropdown size="sm" title='Select Value' onSelect={handleSelect}>
            <Dropdown.Toggle size="sm" style={{ backgroundColor: '#303f9f' }}>
              {filterDate}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item eventKey="Just For Today">Just For Today</Dropdown.Item>
              <Dropdown.Item eventKey="From Yesterday">From Yesterday</Dropdown.Item>
              <Dropdown.Item eventKey="Last 7 Days">Last 7 Days</Dropdown.Item>
              <Dropdown.Item eventKey="Last 30 Days">Last 30 Days</Dropdown.Item>
              <Dropdown.Item eventKey="Last 3 Months">Last 3 Months</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>) : null}
      {loading ? <div style={{ textAlign: 'center', padding: '20px' }}><Spinner animation="border" size="sm" /> Loading...</div> : <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>#</th>
            <th>Date</th>
            <th>Market Name</th>
            <th>Selection Name</th>
            <th>Bet Id</th>
            <th>Bet Type</th>
            <th>Profit/Loss</th>
            <th>Matched Price</th>
            <th>Matched Stake</th>
            <th>Bet Status</th>
          </tr>
        </thead>
        <tbody>
          {(() => {
            const localCancelled = props.type === 'cleared'
              ? JSON.parse(localStorage.getItem('localCancelledBets') || '[]')
              : [];
            const apiIds = (betDetails || []).map(b => b.betId);
            const localOnly = localCancelled.filter(b => !apiIds.includes(b.betId));
            if (localCancelled.some(b => apiIds.includes(b.betId))) {
              localStorage.setItem('localCancelledBets', JSON.stringify(localCancelled.filter(b => !apiIds.includes(b.betId))));
            }
            return [...(betDetails || []), ...localOnly]
              .filter(filterByStaus)
              .filter(filterByBetStaus)
              .filter(filterByDate)
              .map(renderBet);
          })()}
        </tbody>
      </Table>}
    </>
  )
}
export default BfResult